import { create } from "zustand";
import { getSession, signOut, type User, type Session } from "@/lib/api";

interface AuthState {
  user: User | null;
  session: Session["session"] | null;
  isLoading: boolean;
  isAuthenticated: boolean;

  // Actions
  checkAuth: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  session: null,
  isLoading: true,
  isAuthenticated: false,

  checkAuth: async () => {
    set({ isLoading: true });
    try {
      const session = await getSession();
      if (session) {
        set({
          user: session.user,
          session: session.session,
          isAuthenticated: true,
          isLoading: false,
        });
      } else {
        set({
          user: null,
          session: null,
          isAuthenticated: false,
          isLoading: false,
        });
      }
    } catch {
      set({
        user: null,
        session: null,
        isAuthenticated: false,
        isLoading: false,
      });
    }
  },

  logout: async () => {
    try {
      await signOut();
    } finally {
      set({
        user: null,
        session: null,
        isAuthenticated: false,
      });
    }
  },
}));
